import axios from 'axios';

import { getHeaders } from '../helpers/serviceHelper';

import { apiUrls } from './urls';

export default class RecurringService {
    static createNewDonation(model, idempotencyKey, verificationToken) {
        return axios.post(apiUrls.getDonationSubscriptionUrl(),
            model,
            {
                headers: {
                    ...getHeaders(),
                    'Idempotency-Key': idempotencyKey,
                    'Verification': verificationToken
                }
            });
    }

    static createNewDonationV3(model, idempotencyKey, verificationToken) {
        return axios.post(apiUrls.getDonationSubscriptionV3Url(),
            model,
            {
                headers: {
                    ...getHeaders(),
                    'Idempotency-Key': idempotencyKey,
                    'Verification': verificationToken || ""
                }
            });
    }

    static getPaymentFee(orgPath, amount) {
        const requestAmount = amount || 0;
        return axios.get(
            apiUrls.getDonationSubscriptionCoverFeeUrl(orgPath, requestAmount),
            {
                headers: getHeaders()
            });
    }
}